// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3sSVi","content":"LayoutSettings_content__1C3Ml"};